module.exports = __webpack_public_path__ + "img/theme.50a70e40.svg";